import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import client from "@/lib/api";
import { CheckCircle2, Loader2, XCircle, Home } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [plan, setPlan] = useState("");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await client.get(`/payments/status/${sessionId}`);
        setPlan(data.plan || "");
        if (data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setStatus("error"); return; }
      } catch { /* keep polling */ }
      if (attempts >= 8) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-[70vh] grid place-items-center px-4" data-testid="payment-success-page">
      <div className="max-w-md w-full text-center rounded-sm border-2 border-slate-200 dark:border-slate-800 bg-white dark:bg-legend-paper p-10">
        {status === "checking" && (
          <>
            <Loader2 size={56} className="animate-spin text-legend-red mx-auto mb-5" />
            <h1 className="font-display font-black uppercase text-2xl">Conferma in corso…</h1>
            <p className="text-slate-500 mt-2">Stiamo verificando il pagamento con Stripe.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={56} className="text-emerald-500 mx-auto mb-5" />
            <h1 className="font-display font-black uppercase text-3xl">Abbonamento attivo!</h1>
            <p className="text-slate-500 mt-2">Grazie per esserti abbonato{plan ? ` all'${plan}` : ""}. Benvenuto in Legend Magazine!</p>
            <Link to="/" data-testid="success-home-btn" className="mt-6 inline-flex items-center gap-2 bg-legend-red hover:bg-legend-dark text-white font-bold uppercase tracking-wide px-6 py-3 rounded-sm transition-colors">
              <Home size={16} /> Torna alla home
            </Link>
          </>
        )}
        {(status === "error" || status === "timeout") && (
          <>
            <XCircle size={56} className="text-legend-red mx-auto mb-5" />
            <h1 className="font-display font-black uppercase text-2xl">{status === "timeout" ? "Verifica non completata" : "Pagamento non riuscito"}</h1>
            <p className="text-slate-500 mt-2">{status === "timeout" ? "Il pagamento potrebbe richiedere qualche istante. Controlla la tua email." : "Nessun addebito è stato effettuato. Riprova quando vuoi."}</p>
            <Link to="/abbonamenti" className="mt-6 inline-flex items-center gap-2 bg-legend-ink text-white font-bold uppercase tracking-wide px-6 py-3 rounded-sm">Torna agli abbonamenti</Link>
          </>
        )}
      </div>
    </div>
  );
}
